export default {
    search: {
        dataTableId: 'search',
        value: '',
    },
    locale: {
        dataTableId: 'locale:name',
        value: [],
    },
    countries: {
        dataTableId: 'countries:name',
        value: [],
    },
    page: {
        value: 0,
    },
    length: {
        value: 25,
    },
};
